/**
 * @file Filter passed labels
 */
import { Label } from '../../generated/graphql';

import filter, { Options } from '../filter';

type Data = Pick<Label, 'color' | 'id' | 'text'>;

const options: Options<Data> = {
  keys: ['text'],
};

/**
 * Filter passed labels
 *
 * @param search    What the user typed in search box
 * @param labelsAll All the labels available
 * @returns         Filtered array of labels
 */
export const searchLabels = (search: string, labelsAll: Data[]): Data[] => {
  // If nothing is searched, then just return everything
  if (search.trim().length === 0) {
    return labelsAll;
  }
  const labelsSearched = filter(labelsAll, search, options);

  return labelsSearched;
};
